import type { ComponentProps } from 'react';
import { Box, Text } from '@customerio/pluma-components/react';
import { GroupedChecklist, type ToggleDelta } from '@/components/grouped-checklist';

type EventSelectionFieldsetProps = {
  /** Taken from the checklist itself, so this cannot drift from what it accepts. */
  groups: ComponentProps<typeof GroupedChecklist>['groups'];
  selectedItems: string[];
  isDisabled: boolean;
  onChange: (events: string[]) => void;
  /** Bottom margin, for a form that stacks this above the options rather than beside them. */
  mb?: ComponentProps<typeof Box>['mb'];
};

/** The "Select events" fieldset: which events the connector forwards. */
export function EventSelectionFieldset({
  groups,
  selectedItems,
  isDisabled,
  onChange,
  mb,
}: EventSelectionFieldsetProps) {
  return (
    <Box as="fieldset" mb={mb}>
      <Text text="product-h4" as="legend" mb="150">
        Select events
      </Text>
      <GroupedChecklist
        isDisabled={isDisabled}
        groups={groups}
        selectedItems={selectedItems}
        onChange={(delta: ToggleDelta) => onChange(delta.selectedItems)}
      />
    </Box>
  );
}
